/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useState, useContext, useEffect } from 'react'
import { Help } from '../../icons'
import Subscribe from '../../components/pages/subscribe'
import { ServiceCard } from '../../components/core/cards'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'

const Calculator = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])
  useEffect(() => {
    (async () => {

    const data1 = await PagesAPI.getMagazinePageInfo()
    await setInfo(data1.data)
    await setLoad(true)
  
    })();
  }, [])
  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={0} data={steps} />
      </div>
      <h2>
        <Help />
        {language === 'TR' ? 'Neyin hesaplanacağını seçin' : translate.calculate[language]}
      </h2>
      <div className={styles.cards}>
        <ServiceCard
          name={
            language === 'TR'
              ? 'Maaş Kesintilerinin Hesaplanması'
              : translate.deductions?.[language] || 'Əmək haqqından tutulmaların hesablanması'
          }
          detail={false}
          link={'/useful/calculator/1'}
        />
        <ServiceCard
          name={
            language === 'TR'
              ? 'İzin Ücretinin Hesaplanması'
              : translate.severance?.[language] || 'Məzuniyyət haqqının hesablanması'
          }
          detail={false}
          link={'/useful/calculator/2'}
        />
        <ServiceCard
          name={
            language === 'TR'
              ? 'Hamilelik ve Doğum Ödeneği Hesaplanması'
              : translate.pregnancy?.[language] || 'Hamiləliyə və doğuma görə müavinətin hesablanması'
          }
          detail={false}
          link={'/useful/calculator/3'}
        />
        <ServiceCard
          name={
            language === 'TR'
              ? 'İş Sözleşmesinin Feshi ve Son Hesaplaşma'
              : translate.termination_settlement?.[language] || 'Əmək müqaviləsinə xitam və son haqq-hesab'
          }
          detail={false}
          link={'/useful/calculator/4'}
        />
        <ServiceCard
          name={
            language === 'TR'
              ? 'Geçici İş Göremezlik Ödeneği (Hastalık İzni)'
              : translate.sick_leave?.[language] || 'Əmək qabiliyyətinin müvəqqəti itirilməsi (Xəstəlik vərəqəsi)'
          }
          detail={false}
          link={'/useful/calculator/5'}
        />
        <ServiceCard
          name={
            language === 'TR'
              ? 'Görevlendirme ve Harcırah Hesaplanması'
              : translate.business_trip?.[language] || 'Ezamiyyə xərclərinin hesablanması'
          }
          detail={false}
          link={'/useful/calculator/6'}
        />
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Calculator
